var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupOfPersonsWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3215_81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 8.66683C6.66602 9.02045 6.80649 9.35959 7.05654 9.60964C7.30659 9.85969 7.64573 10.0002 7.99935 10.0002C8.35297 10.0002 8.69211 9.85969 8.94216 9.60964C9.19221 9.35959 9.33268 9.02045 9.33268 8.66683C9.33268 8.31321 9.19221 7.97407 8.94216 7.72402C8.69211 7.47397 8.35297 7.3335 7.99935 7.3335C7.64573 7.3335 7.30659 7.47397 7.05654 7.72402C6.80649 7.97407 6.66602 8.31321 6.66602 8.66683Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 14V13.3333C5.33398 12.9797 5.47446 12.6406 5.72451 12.3905C5.97456 12.1405 6.3137 12 6.66732 12H9.33398C9.68761 12 10.0267 12.1405 10.2768 12.3905C10.5268 12.6406 10.6673 12.9797 10.6673 13.3333V14",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33333C10 3.68696 10.1405 4.02609 10.3905 4.27614C10.6406 4.52619 10.9797 4.66667 11.3333 4.66667C11.687 4.66667 12.0261 4.52619 12.2761 4.27614C12.5262 4.02609 12.6667 3.68696 12.6667 3.33333C12.6667 2.97971 12.5262 2.64057 12.2761 2.39052C12.0261 2.14048 11.687 2 11.3333 2C10.9797 2 10.6406 2.14048 10.3905 2.39052C10.1405 2.64057 10 2.97971 10 3.33333Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.334 6.6665H12.6673C13.0209 6.6665 13.3601 6.80698 13.6101 7.05703C13.8602 7.30708 14.0007 7.64622 14.0007 7.99984V8.6665",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 3.33333C3.33398 3.68696 3.47446 4.02609 3.72451 4.27614C3.97456 4.52619 4.3137 4.66667 4.66732 4.66667C5.02094 4.66667 5.36008 4.52619 5.61013 4.27614C5.86018 4.02609 6.00065 3.68696 6.00065 3.33333C6.00065 2.97971 5.86018 2.64057 5.61013 2.39052C5.36008 2.14048 5.02094 2 4.66732 2C4.3137 2 3.97456 2.14048 3.72451 2.39052C3.47446 2.64057 3.33398 2.97971 3.33398 3.33333Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 8.6665V7.99984C2 7.64622 2.14048 7.30708 2.39052 7.05703C2.64057 6.80698 2.97971 6.6665 3.33333 6.6665H4.66667",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3215_81"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupOfPersonsWhite);
export default __webpack_public_path__ + "static/media/GroupOfPersonsWhite.1fae54378af1ff3e395b35368a33e18d.svg";
export { ForwardRef as ReactComponent };